export const uk = {
    'other-sign': 'и ещё {number}',
    'page-name': 'Запрещённые площадки'
};
